import React from "react";
import Header from "@/components/layout/Header";
import { Button } from "@/components/ui/button";
import { ExternalLink } from "lucide-react";

const INVOICING_PORTAL_URL = "https://partner-portal-17lx.bolt.host/";

const InvoicingPage = () => {
  return (
    <div className="font-sans flex flex-col" style={{ height: "100vh", overflow: "hidden" }}>
      <Header />

      {/* Toolbar */}
      <div className="bg-white border-b border-gray-200 shadow-sm shrink-0">
        <div className="container mx-auto px-4 h-12 flex items-center justify-between">
          <span className="text-sm font-bold uppercase tracking-wider text-gray-900">
            Partner Invoicing
          </span>
          <Button
            asChild
            variant="outline"
            size="sm"
            className="text-xs font-bold uppercase tracking-wider"
          >
            <a href={INVOICING_PORTAL_URL} target="_blank" rel="noopener noreferrer" data-testid="open-invoicing-new-tab-btn">
              Open in New Tab <ExternalLink className="ml-2 h-3 w-3" />
            </a>
          </Button>
        </div>
      </div>

      {/* Invoicing Portal iframe - fills ALL remaining viewport */}
      <iframe
        src={INVOICING_PORTAL_URL}
        title="Frog Lake Partner Invoicing"
        className="w-full border-none"
        data-testid="invoicing-iframe"
        allow="clipboard-read; clipboard-write"
        style={{ flex: "1 1 0%", minHeight: 0 }}
      />
    </div>
  );
};

export default InvoicingPage;
